import { useMemo } from 'react'
import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { useAppSelector } from 'hooks/reduxHooks'
import type { StatusMatchCampaignConfig } from 'loyalty/statusMatch/statusMatchTypes'
import { resolveStatusMatchCampaignsFromFlag } from 'loyalty/statusMatch/resolveStatusMatchLabConfig'

/**
 * Returns all active Status Match campaigns for the user's region.
 * Used by the account page/drawer to surface campaigns outside the landing page.
 */
function useActiveStatusMatchCampaigns(): Array<StatusMatchCampaignConfig> {
  const flag = useLabFeatureFlag(LabFeatureFlags.enableStatusMatch)
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)

  return useMemo(
    () => resolveStatusMatchCampaignsFromFlag(flag, regionCode),
    [flag, regionCode],
  )
}

/**
 * Returns the first active Status Match campaign for the user's region.
 * Prefer {@link useActiveStatusMatchCampaigns} when multiple campaigns may be active.
 */
function useActiveStatusMatchCampaign(): StatusMatchCampaignConfig | undefined {
  const campaigns = useActiveStatusMatchCampaigns()
  return campaigns[0]
}

export default useActiveStatusMatchCampaign
export { useActiveStatusMatchCampaigns }
